<template>
	<view class="detail-page">
		
	</view>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight'])
		},
		data() {
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	
</style>
